/**
 * Product thumbnail strip (horizontal) + main-image arrows.
 * Image switching goes through theme.js .clicker-thumb clicks — do not set src here.
 * Hover zoom is disabled to match live product-page behavior.
 */
(function () {
  function patchZoom() {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.zoom) return;
    if (window.jQuery.fn.zoom.__cwDisabled) return;
    var original = window.jQuery.fn.zoom;
    window.jQuery.fn.zoom = function (arg) {
      if (arg !== 'destroy') {
        return this;
      }
      return original.apply(this, arguments);
    };
    window.jQuery.fn.zoom.__cwDisabled = true;
  }

  function hasZoomHandlers() {
    var el = document.getElementById('product-main-image');
    if (!el || !window.jQuery || !window.jQuery._data) return false;
    var ev = window.jQuery._data(el, 'events');
    return !!(ev && ((ev.mouseover && ev.mouseover.length) || (ev.touchstart && ev.touchstart.length)));
  }

  function stripZoom() {
    if (!window.jQuery) return;
    patchZoom();
    var $el = window.jQuery('#product-main-image');
    if (!$el.length) return;
    $el.trigger('zoom.destroy');
    $el.off('.zoom');
    $el.find('.zoomImg').remove();
    $el.css({ overflow: '', position: '' });
  }

  function runZoomFix() {
    patchZoom();
    stripZoom();
    var n = 0;
    var t = setInterval(function () {
      stripZoom();
      n += 1;
      if (!hasZoomHandlers() || n > 50) {
        clearInterval(t);
      }
    }, 80);
  }

  function imageKey(url) {
    if (!url) return '';
    var file = String(url).split('?')[0].split('/').pop();
    return file
      .replace(/_(?:large|grande|medium|compact|pico|master|small|\d+x\d+)(?=\.)/i, '')
      .replace(/\.[a-z0-9]+$/i, '');
  }

  function scrollThumbIntoStrip(scroller, thumb) {
    if (!scroller || !thumb) return;
    var slide = thumb.closest ? thumb.closest('.slide') : thumb.parentNode;
    if (!slide) slide = thumb;
    var sRect = scroller.getBoundingClientRect();
    var tRect = slide.getBoundingClientRect();
    var nextLeft = scroller.scrollLeft;
    if (tRect.left < sRect.left + 2) {
      nextLeft -= sRect.left - tRect.left;
    } else if (tRect.right > sRect.right - 2) {
      nextLeft += tRect.right - sRect.right;
    } else {
      return;
    }
    if (scroller.scrollTo) {
      scroller.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
    } else {
      scroller.scrollLeft = Math.max(0, nextLeft);
    }
  }

  function findThumbForSrc(scroller, src) {
    var key = imageKey(src);
    if (!key) return null;
    var thumbs = scroller.querySelectorAll('.clicker-thumb');
    var i;
    var href;
    var img;
    for (i = 0; i < thumbs.length; i += 1) {
      href = thumbs[i].getAttribute('href') || '';
      img = thumbs[i].querySelector('img');
      if (imageKey(href) === key || (img && imageKey(img.getAttribute('src')) === key)) {
        return thumbs[i];
      }
    }
    return null;
  }

  function thumbsIn(scroller) {
    return scroller.querySelectorAll('.clicker-thumb');
  }

  function currentThumbIndex(scroller) {
    var main = document.querySelector('#product-main-image img');
    var match = findThumbForSrc(scroller, main && main.getAttribute('src'));
    var thumbs = thumbsIn(scroller);
    var i;
    if (!match) return 0;
    for (i = 0; i < thumbs.length; i += 1) {
      if (thumbs[i] === match) return i;
    }
    return 0;
  }

  // Same path as a customer clicking a thumbnail: theme.js
  // $(".clicker-thumb").click(...) sets #product-main-image img src from href.
  function activateThumb(thumb) {
    if (!thumb) return;
    if (window.jQuery) {
      window.jQuery(thumb).trigger('click');
      return;
    }
    var href = thumb.getAttribute('href');
    var main = document.querySelector('#product-main-image img');
    if (href && main) main.setAttribute('src', href);
  }

  function attachJQueryThumbClicks(scroller, handler) {
    if (!window.jQuery || !scroller || scroller.getAttribute('data-cw-thumbs-jq') === '1') return;
    scroller.setAttribute('data-cw-thumbs-jq', '1');
    window.jQuery(scroller).find('.clicker-thumb').on('click.cwThumbs', handler);
  }

  function bindCarousel(root) {
    if (!root || root.getAttribute('data-cw-thumbs-bound') === '1') return;
    var scroller = root.querySelector('.cw-product-thumbs');
    if (!scroller) return;
    root.setAttribute('data-cw-thumbs-bound', '1');

    var page = root.closest ? root.closest('.product-page') : document.querySelector('.product-page');
    var prev = page ? page.querySelector('.cw-gallery-nav--prev') : null;
    var next = page ? page.querySelector('.cw-gallery-nav--next') : null;

    function onThumbActivate() {
      scrollThumbIntoStrip(scroller, this);
    }

    function step(delta, e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var thumbs = thumbsIn(scroller);
      if (!thumbs.length) return;
      var i = currentThumbIndex(scroller);
      var nextIndex = (i + delta + thumbs.length) % thumbs.length;
      activateThumb(thumbs[nextIndex]);
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        step(-1, e);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        step(1, e);
      });
    }

    attachJQueryThumbClicks(scroller, onThumbActivate);

    var mainImg = document.querySelector('#product-main-image img');
    if (mainImg && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        var match = findThumbForSrc(scroller, mainImg.getAttribute('src'));
        if (match) scrollThumbIntoStrip(scroller, match);
      });
      mo.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }
  }

  function initCarousels(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll
      ? root.querySelectorAll('[data-cw-thumbs]')
      : [];
    var i;
    for (i = 0; i < nodes.length; i += 1) {
      bindCarousel(nodes[i]);
    }
    if (root.hasAttribute && root.hasAttribute('data-cw-thumbs')) {
      bindCarousel(root);
    }
  }

  var zoomTries = 0;
  var zoomWait = setInterval(function () {
    zoomTries += 1;
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.zoom) {
      clearInterval(zoomWait);
      window.jQuery(document).on('shopify:section:load', '.product-page', function (event) {
        runZoomFix();
        initCarousels(event.target);
      });
      runZoomFix();
      initCarousels(document);
      document.querySelectorAll('[data-cw-thumbs] .cw-product-thumbs').forEach(function (scroller) {
        attachJQueryThumbClicks(scroller, function () {
          scrollThumbIntoStrip(scroller, this);
        });
      });
    } else if (zoomTries > 80) {
      clearInterval(zoomWait);
    }
  }, 50);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCarousels(document);
    });
  } else {
    initCarousels(document);
  }
})();
